import classes from "./index.module.scss";
import heroTitleClasses from "../../../commons/HeroTitle.module.scss";
import Text from "../../../commons/Text";
import imgWebp from "../images/hero.webp";
import imgPng from "../images/hero.png";
import Container from "../Container";
import Buttons from "../Buttons";
import btnClasses from "../../../commons/Button.module.scss";
import RequestDemo from "../../../Button/RequestDemo";

export default function Hero() {
  return (
    <section className={classes.section}>
      <Container>
        <div className={classes.body}>
          <div className={classes.content}>
            <h1 className={heroTitleClasses.title}>
              Shapely
              <span></span>
            </h1>

            <h3 className={heroTitleClasses.subtitle}>Fitness app</h3>
            <Text
              text={[
                `Shapely is a daily workout app with routines for all your main muscle groups. In just a few minutes a day, you can build muscles and stay fit without having to join a gym.`,
                `Work out from the comfort of your home, anytime you want. No extra equipment is required! Stick with the program and you will see amazing results.`,
              ]}
              className={classes.text}
            />
            <RequestDemo
              className={` ${btnClasses.button} ${classes.btn_small}`}
            />
            <Buttons className={classes.buttons} />
          </div>
          <div className={classes.image}>
            <picture>
              <source srcSet={imgWebp} type="image/webp" />
              <source srcSet={imgPng} type="image/png" />
              <img src={imgPng} alt="Shapely" width={583} height={608} />
            </picture>
          </div>
        </div>
      </Container>
    </section>
  );
}
